import React, { Fragment } from "react"
import classnames from "classnames"
import styles from "./styles.css"

const ToolbarSkeleton = () => {
  return (
    <Fragment>
      <div
        className={classnames(styles.toolbarSkeleton, styles.skeleton)}
      ></div>
    </Fragment>
  )
}

export default ToolbarSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/ToolbarSkeleton/index.js